import axios from './axios';
import { QuestionTemplate } from '../types';

export const fetchQuestionTemplates = async (): Promise<QuestionTemplate[]> => {
  const response = await axios.get('/question-templates');
  return response.data;
};

export const fetchQuestionTemplate = async (id: number): Promise<QuestionTemplate> => {
  const response = await axios.get(`/question-templates/${id}`);
  return response.data;
};

export const createQuestionTemplate = async (template: Omit<QuestionTemplate, 'id' | 'user_id'>): Promise<QuestionTemplate> => {
  const response = await axios.post('/question-templates', template);
  return response.data;
};

export const updateQuestionTemplate = async (id: number, template: Omit<QuestionTemplate, 'id' | 'user_id'>): Promise<QuestionTemplate> => {
  const response = await axios.put(`/question-templates/${id}`, template);
  return response.data;
};

export const deleteQuestionTemplate = async (id: number): Promise<void> => {
  await axios.delete(`/question-templates/${id}`);
};
